import { centsToDollarsDisplay } from "../../displayFormatters";
import { StatisticItem } from "../ReportStatistics";
import { InvoiceReportData } from "./invoiceReportApi";

export const getInvoiceStatistics = (invoices: InvoiceReportData[]): StatisticItem[] => {  
  const unbilledTotal = invoices.reduce((acc, curr) => acc + curr.unbilledAmount, 0)
  const outstandingTotal = invoices.reduce((acc, curr) => acc + curr.invoiceBalance, 0)
  const paidTotal = invoices.reduce((acc, curr) => acc + (curr.totalInvoicedAmount - curr.totalInvoiceBalance), 0)

  return [
    { title: 'Unbilled Total', value: centsToDollarsDisplay(unbilledTotal) || '$0.00' },
    { title: 'Outstanding Total', value: centsToDollarsDisplay(outstandingTotal) || '$0.00' },
    { title: 'Paid Total', value: centsToDollarsDisplay(paidTotal) || '$0.00' }
  ]
}

export const getJobTypes = (items: InvoiceReportData[]): number[] => {
  const jobTypes = new Set<number>();
  items.forEach(item => {
    jobTypes.add(item.jobType);
  });

  return jobTypes.size ? Array.from(jobTypes) : [];
}

export const getFilteredItems = (items: InvoiceReportData[], searchTerm: string, jobTypeSet: Set<number>): InvoiceReportData[] => {
  return items.filter(x =>
    (x.name.toLowerCase().includes(searchTerm) 
      || x.customerDisplayName.toLowerCase().includes(searchTerm)) &&
    (jobTypeSet.size === 0 || jobTypeSet.has(x.jobType))
  );

};